/**
 * 过滤相关数组
 * @param {*} array
 * @param {*} filterArray
 */
export function filter (array: any[], filterArray: any[]) {
  return filterArray.filter(item => {
    return !array.includes(item)
  })
}

/**
 * 数组是否有validateArray所有元素
 * @param {*} array
 * @param {*} validateArray
 */
export function every (array: any[], validateArray: any[]) {
  return validateArray.every(item => {
    return array.includes(item)
  })
}

/**
 * 数组是否有该validateArray任意元素
 * @param {*} array
 * @param {*} validateArray
 */
export function some (array: any[], validateArray: any[]) {
  return validateArray.some(item => {
    return array.includes(item)
  })
}

/**
 * 数组是否有该validateArray任意元素或不存在
 * @param {*} arr
 * @param {*} validateArray
 */
export function isSome (array: any[], validateArray: any[]) {
  return validateArray.some(item => {
    const index = Number(item)
    return (array[index] !== undefined && !array[index]) || array[index]
  })
}

/**
 * 往数组对象追加一空元素
 * @param array
 */
export function addItem (array: any[]) {
  const item: any = {}
  Object.keys(array[0]).forEach((key: string) => {
    item[key] = ''
  })
  array.push(item)
}

/**
 * 从数组中删除指定元素
 * @param array
 * @param item
 */
export function removeItem (array: any[], item: any) {
  var index = array.indexOf(item)
  if (index !== -1) {
    array.splice(index, 1)
    if (array.length === 0) {
      array.push({})
    }
  }
}

/**
 * 从数组中删除指定元素
 * @param array
 * @param item
 */
export function removeItemTime (array: any[], item: any) {
  var index = array.indexOf(item)
  if (index !== -1) {
    array.splice(index, 1)
    if (array.length === 0) {
      array.push([new Date('2022 01 01 00:00'), new Date('2022 01 01 23:59')])
    }
  }
}
